import _implicitStylesheets from "./pdfViewerMainPane.css";

import _implicitScopedStylesheets from "./pdfViewerMainPane.scoped.css?scoped=true";

import {registerTemplate, sanitizeAttribute} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {t: api_text, h: api_element, gid: api_scoped_id, b: api_bind} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    styleDecls: [["font-family", "b-mce", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 0
  }, [api_text("B Mce")]), api_element("div", {
    styleDecls: [["font-family", "ck-beans", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 1
  }, [api_text("Ck Beans")]), api_element("div", {
    styleDecls: [["font-family", "de-bonita", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 2
  }, [api_text("De Bonita")]), api_element("div", {
    styleDecls: [["font-family", "jaime-bien", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 3
  }, [api_text("Jaime Bien")]), api_element("div", {
    styleDecls: [["font-family", "la-belle-aurore", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 4
  }, [api_text("La Belle Aurore")]), api_element("div", {
    styleDecls: [["font-family", "oakhill", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 5
  }, [api_text("Oakhill")]), api_element("div", {
    styleDecls: [["font-family", "oakland-sista", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 6
  }, [api_text("Oakland Sista")]), api_element("div", {
    styleDecls: [["font-family", "qjae", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 7
  }, [api_text("Q Jae")]), api_element("div", {
    styleDecls: [["font-family", "valefont", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 8
  }, [api_text("Valefont")]), api_element("div", {
    styleDecls: [["font-family", "ventilla-script", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 9
  }, [api_text("Ventilla Script")]), api_element("div", {
    styleDecls: [["font-family", "versitia", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 10
  }, [api_text("Versitia")]), api_element("div", {
    styleDecls: [["font-family", "villa-sanjurjo", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 11
  }, [api_text("Villa Sanjurjo")]), api_element("div", {
    styleDecls: [["font-family", "vintlys-hand", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 12
  }, [api_text("Vintlys Hand")]), api_element("div", {
    styleDecls: [["font-family", "viper", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 13
  }, [api_text("Viper")]), api_element("div", {
    styleDecls: [["font-family", "volutes", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 14
  }, [api_text("Volutes")]), api_element("div", {
    styleDecls: [["font-family", "zack-and-sarah", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 15
  }, [api_text("Zack and Sarah")]), api_element("div", {
    styleDecls: [["font-family", "zoey-diary", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 16
  }, [api_text("Zoey's Diary")]), api_element("div", {
    styleDecls: [["font-family", "zou70s", false], ["position", "fixed", false], ["top", "-500px", false], ["left", "-500px", false]],
    key: 17
  }, [api_text("Zou70s")]), api_element("div", {
    classMap: {
      "lock-confirmation-dialog": true
    },
    attrs: {
      "title": "Electronic records and signatures agreements"
    },
    key: 18
  }, [api_text("Please read the "), api_element("a", {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/1oMDbMnfnJrIGysSmMEKH9GUNuS5CvF62TESM6HwF-0A/edit"
    },
    key: 19
  }, [api_text("Electronic Record and Signature Disclosure")]), api_text("."), api_element("br", {
    key: 20
  }, []), api_element("input", {
    classMap: {
      "agreed-to-sign": true
    },
    attrs: {
      "type": "checkbox"
    },
    props: {
      "checked": true
    },
    key: 21
  }, []), api_text(" I agree to use electronic records and signatures.")]), api_element("div", {
    classMap: {
      "slds-hidden": true,
      "info-notification": true
    },
    attrs: {
      "id": api_scoped_id("info-notification")
    },
    key: 22
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true
    },
    key: 23
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_info": true
    },
    attrs: {
      "role": "alert"
    },
    key: 24
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 25
  }, [api_text("info")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true,
      "slds-icon-utility-info": true
    },
    attrs: {
      "title": "Description of icon when needed"
    },
    key: 26
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 27,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#info")
    },
    key: 28,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 29
  }, [api_element("h2", {
    classMap: {
      "info-text": true,
      "slds-text-heading_small": true
    },
    attrs: {
      "id": api_scoped_id("info-text")
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 30
  }, [])]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-notify__close": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 31,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.hideInfoToast))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 32,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 33,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 34
  }, [api_text("Close")])])])])]), api_element("div", {
    classMap: {
      "slds-hidden": true,
      "success-notification": true
    },
    attrs: {
      "id": api_scoped_id("success-notification")
    },
    key: 35
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true
    },
    key: 36
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_success": true
    },
    attrs: {
      "role": "alert"
    },
    key: 37
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 38
  }, [api_text("success")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true,
      "slds-icon-utility-success": true
    },
    attrs: {
      "title": "Description of icon when needed"
    },
    key: 39
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 40,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#success")
    },
    key: 41,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 42
  }, [api_element("h2", {
    classMap: {
      "success-text": true,
      "slds-text-heading_small": true
    },
    attrs: {
      "id": api_scoped_id("success-text")
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 43
  }, [])]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-notify__close": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 44,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.hideSuccessToast))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 45,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 46,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 47
  }, [api_text("Close")])])])])]), api_element("div", {
    classMap: {
      "slds-hidden": true,
      "error-notification": true
    },
    attrs: {
      "id": api_scoped_id("error-notification")
    },
    key: 48
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true
    },
    key: 49
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_error": true
    },
    attrs: {
      "role": "alert"
    },
    key: 50
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 51
  }, [api_text("error")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true,
      "slds-icon-utility-success": true
    },
    attrs: {
      "title": "Description of icon when needed"
    },
    key: 52
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 53,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#error")
    },
    key: 54,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 55
  }, [api_element("h2", {
    classMap: {
      "error-text": true,
      "slds-text-heading_small": true
    },
    attrs: {
      "id": api_scoped_id("error-text")
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 56
  }, [])]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-notify__close": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close",
      "id": api_scoped_id("error-notification-close")
    },
    key: 57,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.hideErrorToast))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 58,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 59,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 60
  }, [api_text("Close")])])])])]), api_element("div", {
    classMap: {
      "slds-hidden": true,
      "warning-notification": true
    },
    attrs: {
      "id": api_scoped_id("warning-notification")
    },
    key: 61
  }, [api_element("div", {
    classMap: {
      "slds-notify_container": true,
      "slds-is-relative": true
    },
    key: 62
  }, [api_element("div", {
    classMap: {
      "slds-notify": true,
      "slds-notify_toast": true,
      "slds-theme_warning": true
    },
    attrs: {
      "role": "alert"
    },
    key: 63
  }, [api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 64
  }, [api_text("warning")]), api_element("span", {
    classMap: {
      "slds-icon_container": true,
      "slds-m-right_small": true,
      "slds-no-flex": true,
      "slds-align-top": true,
      "slds-icon-utility-warning": true
    },
    attrs: {
      "title": "Description of icon when needed"
    },
    key: 65
  }, [api_element("svg", {
    classMap: {
      "slds-icon": true,
      "slds-icon_small": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 66,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#warning")
    },
    key: 67,
    svg: true
  }, [])])]), api_element("div", {
    classMap: {
      "slds-notify__content": true
    },
    key: 68
  }, [api_element("h2", {
    classMap: {
      "warning-text": true,
      "slds-text-heading_small": true
    },
    attrs: {
      "id": api_scoped_id("warning-text")
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 69
  }, [])]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-notify__close": true,
      "slds-button_icon-inverse": true
    },
    attrs: {
      "title": "Close"
    },
    key: 70,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.hideWarningToast))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-button__icon_large": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 71,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "resources/SLDS/icons/utility-sprite/svg/symbols.svg#close")
    },
    key: 72,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 73
  }, [api_text("Close")])])])])]), api_element("div", {
    classMap: {
      "main-pane-content": true
    },
    key: 74
  }, [api_element("form", {
    classMap: {
      "formContainer": true
    },
    attrs: {
      "accept-charset": "UTF-8",
      "enctype": "multipart/form-data",
      "method": "post",
      "id": api_scoped_id("formContainer")
    },
    key: 75
  }, [api_element("div", {
    classMap: {
      "container": true
    },
    styleDecls: [["position", "relative", false]],
    key: 76
  }, [api_element("div", {
    classMap: {
      "pdfPage": true
    },
    attrs: {
      "id": api_scoped_id("editorFrame")
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 77
  }, []), api_element("div", {
    classMap: {
      "pdfPageOverlay": true
    },
    styleDecls: [["position", "absolute", false], ["top", "0", false], ["left", "0", false]],
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 78
  }, [])])])]), api_element("div", {
    classMap: {
      "x-ray-content": true,
      "slds-hidden": true
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 79
  }, []), api_element("div", {
    classMap: {
      "zip-file-content": true,
      "slds-hidden": true
    },
    attrs: {
      "ishtmlcontainer": "true"
    },
    key: 80
  }, [api_element("iframe", {
    classMap: {
      "zipFile-iframe": true
    },
    attrs: {
      "src": ""
    },
    key: 81
  }, [])]), api_element("div", {
    classMap: {
      "wallet-content": true,
      "slds-hidden": true
    },
    attrs: {
      "ishtmlcontainer": "true"
    },
    key: 82
  }, [$cmp.displaywallet ? api_element("iframe", {
    classMap: {
      "wallet-iframe": true
    },
    attrs: {
      "src": $cmp.walletSrc
    },
    key: 83
  }, []) : null, !$cmp.displaywallet ? api_element("div", {
    key: 84
  }, [api_text("Wallet is not enabled")]) : null]), api_element("div", {
    classMap: {
      "sigDrawingDIV": true
    },
    styleDecls: [["border-color", "#000000", false], ["display", "none", false], ["background-color", "#DDDDDD", false], ["z-index", "999999", false], ["width", "100%", false]],
    key: 85
  }, [api_element("div", {
    styleDecls: [["margin", "0 auto", false]],
    classMap: {
      "sigDrawingDIVChildDiv": true
    },
    key: 86
  }, [api_element("form", {
    classMap: {
      "sigPadForm": true
    },
    attrs: {
      "data-id": "sigPadForm"
    },
    key: 87
  }, [api_element("table", {
    styleDecls: [["width", "inherit", false]],
    key: 88
  }, [api_element("tbody", {
    key: 89
  }, [api_element("tr", {
    key: 90
  }, [api_element("td", {
    key: 91
  }, [api_element("div", {
    classMap: {
      "sig": true,
      "sigWrapper": true
    },
    styleDecls: [["background-color", "white", false], ["display", "block", false]],
    key: 92
  }, [api_element("canvas", {
    classMap: {
      "pad": true
    },
    attrs: {
      "width": "562",
      "height": "145"
    },
    key: 93
  }, []), api_element("input", {
    classMap: {
      "output": true
    },
    attrs: {
      "type": "hidden",
      "id": api_scoped_id("inkDraw"),
      "name": "output"
    },
    key: 94
  }, []), api_element("textarea", {
    styleDecls: [["display", "none", false]],
    attrs: {
      "id": api_scoped_id("inkDrawData"),
      "type": "hidden"
    },
    key: 95
  }, [])])])]), api_element("tr", {
    key: 96
  }, [api_element("td", {
    key: 97
  }, [api_element("div", {
    styleDecls: [["margin", "auto", false]],
    key: 98
  }, [api_element("table", {
    styleDecls: [["width", "100%", false]],
    key: 99
  }, [api_element("tbody", {
    key: 100
  }, [api_element("tr", {
    key: 101
  }, [api_element("td", {
    styleDecls: [["text-align", "right", false], ["padding-right", "3px", false], ["white-space", "nowrap", false]],
    key: 102
  }, [api_element("label", {
    attrs: {
      "for": api_scoped_id("clearTextName")
    },
    key: 103
  }, [api_text("Please enter name:")])]), api_element("td", {
    styleDecls: [["text-align", "left", false], ["padding-left", "3px", false]],
    key: 104
  }, [api_element("input", {
    styleDecls: [["width", "200px", false]],
    classMap: {
      "clearTextName": true
    },
    attrs: {
      "type": "text",
      "id": api_scoped_id("clearTextName")
    },
    key: 105
  }, [])])]), api_element("tr", {
    key: 106
  }, [api_element("td", {
    styleDecls: [["text-align", "right", false], ["padding-right", "3px", false], ["padding-top", "3px", false], ["white-space", "nowrap", false]],
    key: 107
  }, [api_element("label", {
    attrs: {
      "for": api_scoped_id("signatureDate")
    },
    key: 108
  }, [api_text("Signature Date:")])]), api_element("td", {
    styleDecls: [["text-align", "left", false], ["padding-left", "3px", false], ["padding-top", "3px", false]],
    key: 109
  }, [api_element("input", {
    styleDecls: [["width", "200px", false]],
    classMap: {
      "signatureDate": true
    },
    attrs: {
      "type": "text",
      "id": api_scoped_id("signatureDate")
    },
    key: 110
  }, [])])]), api_element("tr", {
    key: 111
  }, [api_element("td", {
    styleDecls: [["text-align", "center", false], ["padding-top", "3px", false], ["white-space", "nowrap", false]],
    attrs: {
      "colspan": "99"
    },
    key: 112
  }, [api_element("input", {
    classMap: {
      "saveForDocSigning": true
    },
    attrs: {
      "type": "checkbox",
      "id": api_scoped_id("saveForDocSigning")
    },
    key: 113
  }, []), api_element("label", {
    attrs: {
      "for": api_scoped_id("saveForDocSigning")
    },
    key: 114
  }, [api_text("Save for document signing")])])])])])])])]), api_element("tr", {
    key: 115
  }, [api_element("td", {
    key: 116
  }, [api_element("div", {
    styleDecls: [["float", "left", false], ["padding-left", "9px", false]],
    key: 117
  }, [api_element("input", {
    classMap: {
      "__typeSignature": true
    },
    attrs: {
      "type": "button"
    },
    props: {
      "value": "Type Signature..."
    },
    key: 118
  }, [])]), api_element("div", {
    styleDecls: [["float", "right", false], ["padding-right", "8px", false]],
    key: 119
  }, [api_element("input", {
    classMap: {
      "__btnClear": true,
      "clearButton": true
    },
    styleDecls: [["padding-right", "4px", false]],
    attrs: {
      "type": "button"
    },
    props: {
      "value": "Clear"
    },
    key: 120
  }, []), api_element("input", {
    classMap: {
      "__btnSign": true
    },
    styleDecls: [["padding-right", "4px", false]],
    attrs: {
      "type": "button"
    },
    props: {
      "value": "Sign"
    },
    key: 121
  }, []), api_element("input", {
    classMap: {
      "__btnCancel": true
    },
    attrs: {
      "type": "button"
    },
    props: {
      "value": "Cancel"
    },
    key: 122
  }, [])])])])])])])])]), api_element("div", {
    classMap: {
      "sigTypeSignatureDIV": true
    },
    styleDecls: [["display", "none", false]],
    key: 123
  }, [api_element("table", {
    styleDecls: [["width", "95%", false]],
    key: 124
  }, [api_element("tbody", {
    key: 125
  }, [api_element("tr", {
    key: 126
  }, [api_element("td", {
    key: 127
  }, [api_element("input", {
    classMap: {
      "typeSignatureText": true
    },
    styleDecls: [["width", "100%", false], ["font-family", "b-mce", false], ["font-size", "24px", false], ["padding-bottom", "3px", false]],
    attrs: {
      "type": "text"
    },
    key: 128
  }, [])])]), api_element("tr", {
    key: 129
  }, [api_element("td", {
    styleDecls: [["float", "right", false]],
    key: 130
  }, [api_element("select", {
    classMap: {
      "fontFamilySelect": true
    },
    attrs: {
      "data-id": "font-select"
    },
    key: 131
  }, [api_element("option", {
    styleDecls: [["font-family", "b-mce", false]],
    attrs: {
      "value": "b-mce:38",
      "selected": "selected"
    },
    key: 132
  }, [api_text("B McE")]), api_element("option", {
    styleDecls: [["font-family", "ck-beans", false]],
    attrs: {
      "value": "ck-beans:48"
    },
    key: 133
  }, [api_text("CK Beans")]), api_element("option", {
    styleDecls: [["font-family", "de-bonita", false]],
    attrs: {
      "value": "de-bonita:56"
    },
    key: 134
  }, [api_text("De Bonita")]), api_element("option", {
    styleDecls: [["font-family", "jaime-bien", false]],
    attrs: {
      "value": "jaime-bien:60"
    },
    key: 135
  }, [api_text("Jaime Bien")]), api_element("option", {
    styleDecls: [["font-family", "la-belle-aurore", false]],
    attrs: {
      "value": "la-belle-aurore:48"
    },
    key: 136
  }, [api_text("La Belle Aurore")]), api_element("option", {
    styleDecls: [["font-family", "oakhill", false]],
    attrs: {
      "value": "oakhill:38"
    },
    key: 137
  }, [api_text("Oakhill")]), api_element("option", {
    styleDecls: [["font-family", "oakland-sista", false]],
    attrs: {
      "value": "oakland-sista:56"
    },
    key: 138
  }, [api_text("Oakland Sista")]), api_element("option", {
    styleDecls: [["font-family", "qjae", false]],
    attrs: {
      "value": "qjae:46"
    },
    key: 139
  }, [api_text("Q Jae")]), api_element("option", {
    styleDecls: [["font-family", "valefont", false]],
    attrs: {
      "value": "valefont:46"
    },
    key: 140
  }, [api_text("Valefont")]), api_element("option", {
    styleDecls: [["font-family", "ventilla-script", false]],
    attrs: {
      "value": "ventilla-script:66"
    },
    key: 141
  }, [api_text("Ventilla Script")]), api_element("option", {
    styleDecls: [["font-family", "versitia", false]],
    attrs: {
      "value": "versitia:46"
    },
    key: 142
  }, [api_text("Versitia")]), api_element("option", {
    styleDecls: [["font-family", "villa-sanjurjo", false]],
    attrs: {
      "value": "villa-sanjurjo:46"
    },
    key: 143
  }, [api_text("Villa Sanjurjo")]), api_element("option", {
    styleDecls: [["font-family", "vintlys-hand", false]],
    attrs: {
      "value": "vintlys-hand:56"
    },
    key: 144
  }, [api_text("Vintlys Hand")]), api_element("option", {
    styleDecls: [["font-family", "viper", false]],
    attrs: {
      "value": "viper:48"
    },
    key: 145
  }, [api_text("Viper")]), api_element("option", {
    styleDecls: [["font-family", "volutes", false]],
    attrs: {
      "value": "volutes:56"
    },
    key: 146
  }, [api_text("Volutes")]), api_element("option", {
    styleDecls: [["font-family", "zack-and-sarah", false]],
    attrs: {
      "value": "zack-and-sarah:52"
    },
    key: 147
  }, [api_text("Zack and Sarah")]), api_element("option", {
    styleDecls: [["font-family", "zoey-diary", false]],
    attrs: {
      "value": "zoey-diary:52"
    },
    key: 148
  }, [api_text("Zoey's Diary")]), api_element("option", {
    styleDecls: [["font-family", "zou70s", false]],
    attrs: {
      "value": "zou70s:56"
    },
    key: 149
  }, [api_text("Zou70s")])])])])])])]), api_element("div", {
    classMap: {
      "dynamic-dialogs-container": true
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 150
  }, [])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-pdfViewerMainPane_pdfViewerMainPane"
